// extracted by mini-css-extract-plugin
export default {"cardsRow":"CardsRow_cardsRow__VYBG0"};